import React, {useEffect, useState} from "react";

const TextArea = props => {
    const {className, value = "", ...other } = props;
    const [text, setText] = useState(value);

    const handleChange = (event) => {
        setText(event.target.value);
    };

    useEffect(() => {
        setText(value);
    }, [value]);

    return (
        <textarea
            className={"ch-textarea" + (className ? " " +className : "")}
            value={text}
            onChange={handleChange}
            {...other}
        />
    );
};

export default TextArea;